import React, {useEffect, useState} from "react";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import Loader from "../../../primer/POPUP-COMPONENTS/Loader/PrimerLoader";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import {setIEBookRequestData, setIEBookResponseData} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import Dropdown from "../../../primer/Dropdown";
import {getGreekNumberFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import * as XLSX from "xlsx";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import Pagination from "../../../primer/Pagination";
import {openAccountingRecord} from "../../../../_helpers/tabOpeners";

const AccountingReportIEBook = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const requestData = useSelector((state) => state.ACCOUNTING_DATA.ieBookRequestData[tabKey]);
    const responseData = useSelector((state) => state.ACCOUNTING_DATA.ieBookResponseData[tabKey]);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const installationOptions = useInstallationOptions(true);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);

    const bookOptions = [
        {label: "Βιβλίο εσόδων", value: "income"},
        {label: "Βιβλίο εξόδων", value: "expense"},
    ]

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setIEBookRequestData(reqData));
        }
        axios.post(process.env.REACT_APP_API_URL2 + "/report/accounting-ie-book", {
            ...reqData,
            company: company.id,
            year: company.year
        }, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setIEBookResponseData(res.data.data));
                if (!fromPagination) toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
            } else {
                if (!fromPagination) toast.error(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            if (!fromPagination) toast.error("Πρόβλημα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleEnter = (e) => {
        if (e.key === "Enter") fetchReport();
    }

    const handleFilterChange = (e, type, name) => {
        const prepChange = {};
        if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "dropdown") {
            prepChange[name] = e.value;
        } else if (type === "checkbox") {
            prepChange[name] = e.target.checked;
        } else if (type === "msdd") {
            prepChange[name] = e.flatMap((o) => o.value);
        }
        dispatch(setIEBookRequestData({...requestData, ...prepChange}));
    }

    const dataCollection = async () => {
        try {
            const res = await axios.post(process.env.REACT_APP_API_URL2 + "/report/accounting-ie-book", {
                ...requestData,
                company: company.id,
                year: company.year,
                page: -1,
            }, {
                headers: { "Content-Type": "application/json" }
            });
            if (res.data.status === "200") return res.data.data.data;
        } catch {}
        return [];
    }

    const handleExcelExport = async () => {
        let dateFrom = requestData.date_from;
        let dateTo = requestData.date_to;
        if (isEmpty(dateFrom)) dateFrom = moment(company.year, "YYYY", true).startOf("year").format("DD/MM/YYYY");
        if (isEmpty(dateTo)) dateTo = moment(company.year, "YYYY", true).endOf("year").format("DD/MM/YYYY");
        const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");

        const resData = await dataCollection();
        const rows = [];
        rows.push(["Επωνυμία:", company.name]);
        rows.push(["ΑΦΜ:", company.vatNumber]);
        rows.push(["ΔΟΥ:", companyDetails.doy]);
        rows.push([`Εύρος ημερομηνίας: ${dateFrom} - ${dateTo}`]);
        rows.push([`Ημερομηνία Εξαγωγής: ${dateExported}`]);
        rows.push([]);

        rows.push(responseData.columns);
        for (const row of resData) {
            const prepRow = [];
            if (row["Παραστατικό"] === "PREVIOUS_MOVEMENT") {
                prepRow.push("");
                prepRow.push("ΑΠΟ ΜΕΤΑΦΟΡΑ");
                prepRow.push("");
                for (const col of responseData.columns.slice(3)) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            } else if (row["Παραστατικό"] === "TOTALS") {
                prepRow.push("");
                prepRow.push("ΓΕΝΙΚΑ ΣΥΝΟΛΑ");
                prepRow.push("");
                for (const col of responseData.columns.slice(3)) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            } else if (row["Παραστατικό"] === "PAGE_TOTALS") {
                prepRow.push("");
                prepRow.push("ΣΥΝΟΛΑ ΣΕΛΙΔΑΣ");
                prepRow.push("");
                for (const col of responseData.columns.slice(3)) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            } else {
                for (const col of responseData.columns) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            }
            rows.push(prepRow);
        }
        const workSheet = XLSX.utils.aoa_to_sheet(rows);
        const workBook = XLSX.utils.book_new();
        const displayName = `Βιβλίο ${requestData.bookOption === "income" ? "Εσόδων" : "Εξόδων"}`
        XLSX.utils.book_append_sheet(workBook, workSheet, displayName);
        XLSX.writeFile(workBook, `${displayName}.xlsx`);
    }

    const handlePDFExport = async () => {
        const displayName = `Βιβλίο ${requestData.bookOption === "income" ? "Εσόδων" : "Εξόδων"}`
        const doc = new jsPDF('landscape');
        let y = 23;
        doc.addFileToVFS("arialuni.ttf", liberationSerif);
        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
        doc.setFont("DejaVu Sans Bold");
        doc.setFontSize(12);
        let dateFrom = requestData.date_from;
        let dateTo = requestData.date_to;
        if (isEmpty(dateFrom)) dateFrom = moment(company.year, "YYYY", true).startOf("year").format("DD/MM/YYYY");
        if (isEmpty(dateTo)) dateTo = moment(company.year, "YYYY", true).endOf("year").format("DD/MM/YYYY");
        const header = doc.splitTextToSize(`${displayName} περιόδου από ${dateFrom} έως ${dateTo}`, 200);
        const headerString = header.join("\n");
        doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
        doc.setFont("DejaVu Sans Normal");
        doc.setFontSize(9);
        doc.text(`${company.name}, ΑΦΜ: ${company.vatNumber}`, 15, 17, {alignment: "center"});
        doc.text(`ΔΟΥ: ${companyDetails.doy}`, 15, 21, {alignment: "center"});
        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY")}`, 190, 21, {alignment: "center"});
        const imgData = 'assets/images/prrimer-logo.png';
        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
        const imgY = 3; // adjust the position as needed
        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
        doc.setFont("DejaVu Sans Normal");

        const resData = await dataCollection();
        let rows = [];
        for (const row of resData) {
            const prepRow = [];
            if (row["Παραστατικό"] === "PREVIOUS_MOVEMENT") {
                prepRow.push("");
                prepRow.push("ΑΠΟ ΜΕΤΑΦΟΡΑ");
                prepRow.push("");
                for (const col of responseData.columns.slice(3)) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            } else if (row["Παραστατικό"] === "TOTALS") {
                prepRow.push("");
                prepRow.push("ΓΕΝΙΚΑ ΣΥΝΟΛΑ");
                prepRow.push("");
                for (const col of responseData.columns.slice(3)) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            } else if (row["Παραστατικό"] === "PAGE_TOTALS") {
                prepRow.push("");
                prepRow.push("ΣΥΝΟΛΑ ΣΕΛΙΔΑΣ");
                prepRow.push("");
                for (const col of responseData.columns.slice(3)) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            } else {
                for (const col of responseData.columns) {
                    prepRow.push((isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col]));
                }
            }
            rows.push(prepRow);
        }
        autoTable(doc, {
            startY: y,
            head: [responseData.columns],
            body: rows,
            rowPageBreak: "avoid",
            styles: {
                font: "DejaVu Sans Normal",
                fontStyle: "normal",
                fontSize: 9,
                halign: "center",
            },
        })
        const pageCount = doc.getNumberOfPages();
        // Add the pagination to each page
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
        }
        doc.save(`${displayName}.pdf`);
    }

    const handlePageChange = (num) => {
        dispatch(setIEBookRequestData({...requestData, page: num}));
        setPageChanged(true);
    }

    return (
        <React.Fragment>
            {loading && (<Loader doNotShowSmallText={true} />)}
            <div hidden={loading} onKeyDown={handleEnter}>
                <Row>
                    <Col md={2}>
                        <Dropdown
                            name={"bookOption"}
                            options={bookOptions}
                            label={"Τύπος Βιβλίου"}
                            key={requestData.bookOption}
                            defaultValue={bookOptions.find((el) => el.value === requestData.bookOption)}
                            onChange={(e) => handleFilterChange(e, "dropdown", "bookOption")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => dispatch(setIEBookRequestData({...requestData, date_from: from, date_to: to}))}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_from"
                            selected={requestData.date_from !== "" ? moment(requestData.date_from, "DD-MM-YYYY").toDate() : ""}
                            label={"Ημερομηνία από"}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_to"
                            selected={requestData.date_to !== "" ? moment(requestData.date_to, "DD-MM-YYYY").toDate() : ""}
                            label={"Ημερομηνία μέχρι"}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_to")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            name={"installation"}
                            label={"Εγκατάσταση"}
                            options={installationOptions}
                            key={requestData.installation}
                            defaultValue={installationOptions.find((el) => el.value === requestData.installation) ? installationOptions.find((el) => el.value === requestData.installation) : ""}
                            onChange={(e) => handleFilterChange(e, "dropdown", "installation")}
                        />
                    </Col>
                    <Col md={2}>
                        <Button onClick={() => fetchReport()} style={{marginTop: "23px", width: "100%"}} disabled={loading}>
                            Ανανέωση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                </Row>
                {responseData.data.length > 0 && (
                    <React.Fragment>
                        <Row>
                            <Col md={4} className={"mb-2"}>
                                <Button size={"sm"} onClick={() => handleExcelExport()}>Εξαγωγή XLSX</Button>
                                <Button size={"sm"} className={"ml-1"} onClick={() => handlePDFExport()}>Εξαγωγή PDF</Button>
                            </Col>
                            <Col md={8} className={"mb-2 d-flex justify-content-end"}>
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(e) => handlePageChange(e)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <table className={"simpleClassicTable simpleClassicTableGrayHover"}>
                                    <thead>
                                    <tr>
                                        {responseData.columns.map((col, idx) => (
                                            <th key={`tHead-col-${idx}`}>{col}</th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {responseData.data.map((row, idx) => {
                                        if (row["Παραστατικό"] === "PREVIOUS_MOVEMENT") {
                                            return (
                                                <tr key={`tableRow-${idx}`} style={{fontWeight: 600, backgroundColor: "lightgray"}}>
                                                    <td colSpan={3}>ΑΠΟ ΜΕΤΑΦΟΡΑ</td>
                                                    {responseData.columns.slice(3).map((col, idx2) => (
                                                        <td key={`tableRowCol-${idx}-${idx2}`}>
                                                            {(isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col])}
                                                        </td>
                                                    ))}
                                                </tr>
                                            )
                                        } else if (row["Παραστατικό"] === "TOTALS") {
                                            return (
                                                <tr key={`tableRow-${idx}`} style={{fontWeight: 600, backgroundColor: "lightgray"}}>
                                                    <td colSpan={3}>ΓΕΝΙΚΑ ΣΥΝΟΛΑ</td>
                                                    {responseData.columns.slice(3).map((col, idx2) => (
                                                        <td key={`tableRowCol-${idx}-${idx2}`}>
                                                            {(isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col])}
                                                        </td>
                                                    ))}
                                                </tr>
                                            )
                                        } else if (row["Παραστατικό"] === "PAGE_TOTALS") {
                                            return (
                                                <tr key={`tableRow-${idx}`} style={{fontWeight: 600, backgroundColor: "lightgray"}}>
                                                    <td colSpan={3}>ΣΥΝΟΛΑ ΣΕΛΙΔΑΣ</td>
                                                    {responseData.columns.slice(3).map((col, idx2) => (
                                                        <td key={`tableRowCol-${idx}-${idx2}`}>
                                                            {(isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col])}
                                                        </td>
                                                    ))}
                                                </tr>
                                            )
                                        } else {
                                            return (
                                                <tr key={`tableRow-${idx}`} onDoubleClick={() => {
                                                    if (row._id) {
                                                        openAccountingRecord(dispatch, TABS_DATA, company.id, row._id);
                                                    }
                                                }}>
                                                    {responseData.columns.map((col, idx2) => (
                                                        <td key={`tableRowCol-${idx}-${idx2}`}>
                                                            {(isEmpty(row[col]) || +isNaN(row[col])) ? row[col] : getGreekNumberFormat(row[col])}
                                                        </td>
                                                    ))}
                                                </tr>
                                            )
                                        }
                                    })}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    )
}

export default AccountingReportIEBook;
